<template>
  <div class="safety-task-record-detail">
    <list-page>
      <list-table background-color="#FFF" :show-shadow="false" class="list-table">
        <form-tag label="任务信息"/>
        <!-- 表单主体信息 -->
        <form-items label-width="2.4rem" icon-width="0" :columns="2">
          <form-item label="计划名称">
            <span class="readonly-text">{{ dataDetail.templateName }}</span>
          </form-item>
          <form-item label="项目名称">
            <span class="readonly-text">{{ dataDetail.projectName }}</span>
          </form-item>
          <form-item label="工地名称">
            <span class="readonly-text">{{ dataDetail.siteName }}</span>
          </form-item>
          <form-item label="班组名称">
            <span class="readonly-text">{{ dataDetail.classmateName }}</span>
          </form-item>
          <form-item label="巡检人员">
            <span class="readonly-text">{{ dataDetail.userName }}</span>
          </form-item>
          <form-item label="巡检时间">
            <span class="readonly-text">{{ dataDetail.taskTime }}</span>
          </form-item>
          <form-item label="任务状态">
            <el-tag type="info" v-if="dataDetail.taskStatus === 0">未执行</el-tag>
            <el-tag type="success" v-else-if="dataDetail.taskStatus === 1">已完成</el-tag>
          </form-item>
          <form-item label="提交时间">
            <span class="readonly-text">{{ dataDetail.taskTimeExecute }}</span>
          </form-item>
        </form-items>

        <form-tag label="巡检结果"/>
        <form-items label-width="2.4rem" icon-width="0" :columns="2">
          <form-item label="巡检结果">{{dataDetail.checkResult === 1? '正常': '异常'}}</form-item>
          <form-item label="施工点位">{{dataDetail.constructSite}}</form-item>
          <form-item label="巡检图片" :show-block="true">
            <image-upload v-model="dataDetail.contentImages" :disabled="true"/>
          </form-item>
          <form-item label="结果描述" :show-block="true">
            <el-input v-model="dataDetail.content" :disabled="true" type="textarea" autosize/>
          </form-item>
          <form-item label="备注" :show-block="true">
            <el-input v-model="dataDetail.remark" :disabled="true" type="textarea" autosize/>
          </form-item>
        </form-items>
        <!-- 明细行内容 -->
        <div v-if="dataDetail.detailList && dataDetail.detailList.length > 0" class="detail-section">
          <form-tag label="任务明细"></form-tag>
          <form-items label-width="2.4rem" icon-width="0">
            <form-item v-for="item in dataDetail.detailList" :key="item.id" :label="item.columnLabel">
              <image-show v-model="item.columnTypeValue" v-if="item.columnTypeDisplay === 'image'"/>
              <span v-else>{{item.columnTypeValue}}</span>
            </form-item>
          </form-items>

        </div>
        <!-- 无明细时的提示 -->
        <div v-else class="empty-detail">
          <yq-empty description="暂无任务明细"/>
        </div>
      </list-table>

      <form-page :show-page="false" :show-shadow="false">
        <page-button type="read" el-type="primary" @click="goBack">返回</page-button>
      </form-page>
    </list-page>
  </div>
</template>

<script>
import {useRoute, useRouter} from "vue-router";
import safetyTaskRecordsApi from "@/api/dz-luqiao/safetyTaskRecordsApi";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import YqTable from "@/components/h5/table/YqTable.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import FormTag from "@/components/h5/layout/FormTag.vue";
import ImageShow from "@/components/h5/image/ImageShow.vue";
import Util from "@/util/util";
import ImageUpload from "@/components/h5/image/ImageUpload.vue";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "SafetyTaskRecordDetail",
  components: {
    ImageUpload,
    FormItems,
    FormItem,
    ListTable,
    FormPage,
    ListPage,
    PageButton,
    YqTable,
    YqTableColumn, FormTag, ImageShow
  },
  data() {
    return {
      dataDetail: {}
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (this.route.query.id) {
      this.init(this.route.query.id);
    }
  },
  methods: {
    init(id) {
      safetyTaskRecordsApi.findById(id).then(detail => {
        this.dataDetail = detail;
      });
    },
    goBack() {
      this.router.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.safety-task-record-detail{
  .list-table{
    box-sizing: border-box;
    padding: 20px;
  }
}
.readonly-text {
  color: #303133;
  font-size: 14px;
}

.detail-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e4e7ed;
}

.detail-table {
  border-radius: 8px;
  overflow: hidden;
}

.empty-detail {
  margin-top: 16px;
  padding: 40px 0;
  text-align: center;
}
</style>